import { render, staticRenderFns } from "./FlagshipGoalsStepIndicator.vue?vue&type=template&id=6a76b613&"
import script from "./FlagshipGoalsStepIndicator.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsStepIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports